<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="userService"
    [idKey]="'userId'"
></base-index-page>